module.exports = __webpack_public_path__ + "static/media/penguin-banner.acf276d6.svg";